export enum UserOrganizationTypes {
    school = 'school',
    preschool = 'preschool',
    PTA_PTO = 'PTA_PTO',
    district = 'district',
    college = 'college',    
    graduate_school = 'graduate_school',
    hospital = 'hospital',
    clinical_practice = 'clinical_practice',
    camp = 'camp',
    after_school_program = 'after_school_program',
    other = 'other',
}
